import { QueryFunctionContext } from '@tanstack/react-query'
import { UrlService } from 'shared/services/MttUrlService'

export const QUERY_KEY = 'url_service'

export const queryUrl = (context: QueryFunctionContext<VP.MTT.Queries.Url.UrlQueryKey>): Promise<string> => {
  const { queryKey } = context
  const [, { locale, urlId }] = queryKey

  return UrlService.getSpecificUrl(locale, urlId)
}
